// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'

export interface DeleteUserDevice {
  userDeviceId: number
}

export interface SimpleResponse {
  errorText?: string
  ok: boolean
}

/**
 * Validate DeleteUserDevice request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateDeleteUserDevice(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateDeleteUserDevice(request: DeleteUserDevice): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.userDeviceId === undefined || req.userDeviceId === null) {
    errors.push({
      field: 'userDeviceId',
      code: 'required',
      message: 'userDeviceId is required'
    })
  }

  return errors
}

export const deleteUserDevice = postEndpoint<DeleteUserDevice, SimpleResponse>('/user/deleteUserDevice')
